import { Appendix } from "../../../../../../shared/entities/scripts/appendix";
import { Study } from "../../../../../../shared/entities/scripts/study";
import { FormatDate, GetDateFromString } from "../../../../../../shared/scripts/date-functions";
import { FormatNumberWithCommas } from "../../../../../../shared/scripts/number-functions";
import { RenderDateMDY } from "../../../../../../shared/scripts/table-functions";
import { SiteInfo } from "../../../../sites/shared/sites.entities";
import { AssessmentEvent } from "./assessments.entities";
import { AssessmentLookup } from "./assessments.lookup";
import { VisitLookup } from "../../visits-tab/scripts/visits.lookup";


export class AssessmentsDialog {
    static table: any = undefined;

    static Initialize() {
        AssessmentsDialog.table = $('#assessments-details-modal #dialog-details-table').DataTable({
            //retrieve: true,
            autoWidth: true,
            //"order": [[3, "asc"]],
            info: false,
            paging: false,
            scrollX: true,
            scrollY: '70vh',
            searching: false,
            columns: [
                //{ data: "Study", title: "Platform", className: "text-left font-size12 nowrap" },
                { data: "Appendix", title: "Trial", className: "text-left font-size12 nowrap" },
                { data: "SiteNumber", title: "Site", className: "text-left font-size12 nowrap" },
                { data: { _: "VisitOrdering", display: "Visit", sort: "VisitOrdering" }, title: "Visit", className: "text-left font-size12 nowrap" },
                { data: "AssessmentName", title: "Assessment", className: "text-left font-size12 nowrap" },
                { data: "AssessmentStatus", title: "Status", className: "text-left font-size12 nowrap" },               
                { data: "Subject", title: "Participant", className: "text-left font-size12 nowrap" },
                { data: "TargetDate", title: " Visit Target Date", className: "text-left font-size12 nowrap", render: RenderDateMDY },    
                { data: "PercentComplete", title: "Percent Complete", className: "text-left font-size12 nowrap",render: (data) => `${data}%`},
            ],
            buttons: [
                {
                    extend: 'csv',
                    className: "btn btn-secondary",
                    text: '<i class="fas fa-file-download"></i>',
                    charset: 'utf-8',
                    title: "RECOVER-CT Assessments Details Export",
                }
            ],
        }); 

        document.getElementById("export-assessments-btn-dialog")?.addEventListener("click", () => {
            AssessmentsDialog.table.button('.buttons-csv').trigger();
        });
    }
  
    public static ShowDialog(visits: AssessmentEvent[]): void {
        //console.log("show", visits);
        let tableRows: AssessmentDialogRow[] = visits.map((v: AssessmentEvent) => new AssessmentDialogRow(v));
        //console.log(tableRows);

        if (AssessmentsDialog.table == undefined) { AssessmentsDialog.Initialize(); }

        AssessmentsDialog.table.clear();
        AssessmentsDialog.table.rows.add(tableRows).draw();

        $('#assessments-details-modal').on('shown.bs.modal', () => {
            AssessmentsDialog.table.columns.adjust();
            $('#assessments-details-modal .dataTables_scrollBody').scrollTop(0);
            $('#assessments-details-modal #modal-title').text("Number of Assessments = " + FormatNumberWithCommas(visits.length + ""));
            //$('#visits-details-modal-count').text(visits.length);
        });

        $('#assessments-details-modal').modal('show');

    }
}


export class AssessmentDialogRow {
    Study: string;
    Appendix: string;
    SiteNumber: string;
    Subject: string;
    Visit: string;
    VisitOrdering: number;
    AssessmentName: string;
    AssessmentStatus: string;
    PercentComplete: number;
    TargetDate: string;
    

    constructor(event: AssessmentEvent) {
        this.Study = Study.GetStudyName(event.StudyId);
        //console.log('Study:', this.Study);

        this.Appendix = Appendix.GetAppendixName(event.AppendixId);
        //.log('Appendix:', this.Appendix);

        this.SiteNumber = SiteInfo.FormatSiteNumber(event.SiteNumber);
        //console.log('SiteNumber:', this.SiteNumber);

        this.Subject = event.SubjectId;
        //console.log('Subject:', this.Subject);

        this.Visit = VisitLookup.GetVisitMasterColumn(event.TimepointId);
        //console.log('Visit:', this.Visit);

        this.VisitOrdering = VisitLookup.GetVisitMasterOrdering(event.TimepointId);
        //console.log('VisitOrdering:', this.VisitOrdering);

        this.AssessmentName = AssessmentLookup.GetNameColumn(event.NameId);
        //console.log('AssessmentName:', this.AssessmentName);

        this.AssessmentStatus = AssessmentLookup.GetStatusColumn(event.StatusId);
        //console.log('AssessmentStatus:', this.AssessmentStatus);

        this.PercentComplete = event.PercentComplete;

        this.TargetDate = event.TargetDate;
        //console.log('PercentComplete:', this.PercentComplete);
    }
}
